import { useEffect } from 'react';
import { useOfflineDownloadStatusStore } from '../stores/offlineDownloadStatus/offlineDownloadStatus.store';

interface UseHandleWithIncompletelyCacheParams {
  removeOfflineData: () => Promise<void>;
}

export const useHandleWithIncompletelyCache = ({
  removeOfflineData,
}: UseHandleWithIncompletelyCacheParams) => {
  const handleWithIncompletelyCache = () => {
    const unsubscribe = useOfflineDownloadStatusStore.persist.onFinishHydration((state) => {
      const shouldRemoveIncompletelyCachedData =
        state.cachedData?.lastSyncedAt && !state.cachedData?.finishedDownloadAt;

      if (shouldRemoveIncompletelyCachedData) {
        removeOfflineData();
      }

      unsubscribe();
    });
  };

  useEffect(() => {
    handleWithIncompletelyCache();
  }, []);
};
